import { ActionItem, Avatar, Box } from '@factorialco/deprecated-design-system'
import { SettingsPayrollEmployeeGroupEmployeeFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'

import styles from '../index.module.scss'

interface Props {
  employee: SettingsPayrollEmployeeGroupEmployeeFragment
}

const EmployeeListItem = ({ employee }: Props) => {
  const { navigation } = useNavigation()

  const to = navigation.employees.id.fullPath({ id: employee.id })

  return (
    <ActionItem key={`employee_list_item_${employee.id}`} to={to} whiteDisabled>
      <Box className={styles.column}>
        <Box className={styles.item} flexDirection="row">
          <Avatar size="s32" url={buildUrl(employee.access.avatar)} label={employee.fullName} />
          <Box className={styles.title}>{employee.fullName}</Box>
        </Box>
      </Box>
    </ActionItem>
  )
}

export default EmployeeListItem
